import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { userFacingError } from '../../i18n/userFacingError';

export default function QueryErrorBanner({ error, onRetry, className = '' }) {
  if (!error) return null;
  return (
    <div
      className={`flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800 ${className}`}
      role="alert"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="flex-1">
        <p className="font-medium">Não foi possível carregar os dados.</p>
        <p className="mt-0.5 text-red-700">{userFacingError(error, 'loadError')}</p>
      </div>
      {onRetry ? (
        <button type="button" className="btn btn-outline btn-sm shrink-0" onClick={onRetry}>
          Tentar de novo
        </button>
      ) : null}
    </div>
  );
}
